import { localized, t } from '@weavedev/lit-i18next';
import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';

import { baseStyles, buttonStyles, rootVariablesStyles } from '@/styles';

@customElement('fg-quantity-variant-input-message')
@localized()
export class FgQuantityVariantInputMessage extends LitElement {
  render() {
    return html`
      <p>${t('errors.variantPerQuantityIsInvalid')}</p>
    `;
  }

  static styles = [
    buttonStyles,
    baseStyles,
    rootVariablesStyles,
    css`
      p {
        color: var(--fg-warning--dark, var(--fg-fallback-warning--dark));
        font-size: 0.875rem;
      }
    `,
  ];
}
